import VueRouter from 'vue-router';
import { Jurisdiction } from '@gig/magic-jurisdictions';

import { RouteName } from '../../../routes/routes.constants';
import { getUserJurisdiction } from '../helpers/jurisdiction.helpers';
import { BANK_ID_STEPS } from '@gig/magic-account/dist/components/bank-id/sign-up/sign-up.constants';
import { magic } from '@gig/magic-sdk/dist/magic';
import { isRouteActive } from '../helpers/routes';
import { USER_REQUIRES_TERMS_ACCEPTANCE_QUERY } from '@gig/magic-messages';

export function initSgaIncompleteGuard(router: VueRouter) {
    router.beforeResolve(async (to, _, next) => {

        const user = magic.session.getUser();

        if (!user) {
            return next();
        }

        if (!(await isSGA())) {
            return next();
        }

        if (user.isCompleted) {
            return isRouteActive(RouteName.SIGN_UP_BANKID,to,router)
                ? next({ name: RouteName.GAMES, params: { language: to.params.language }})
                : next();
        }

        if (isRouteActive(RouteName.SIGN_UP_BANKID,to,router)){
            return next();
        }

        if (await hasPendingConsents()) {
            return next();
        }

        return next({
            name: RouteName.SIGN_UP_BANKID,
            params: {
                language: to.params.language,
                step: BANK_ID_STEPS.STEP3,
            },
        });
    });
}

async function isSGA(): Promise<boolean> {
    return (await getUserJurisdiction()) === Jurisdiction.SGA;
}

function hasPendingConsents() {
    return window.queryBus.query<boolean>(USER_REQUIRES_TERMS_ACCEPTANCE_QUERY);
}
